export class WebConfig {
  static REACT_APP_API_URL = "";
  static REACT_APP_PUBLIC_FILE_BASE_URL = "";
  static REACT_APP_AAI_SSO_BASE_URL = "";
}
